import React from 'react';
import { useInView } from '../hooks/useInView';
import { useLanguage } from '../context/LanguageContext';

const AboutSection = () => {
  const { t } = useLanguage();
  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section
      id="o-nama"
      ref={ref}
      className="py-24 lg:py-32 bg-black"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left Column - Title */}
          <div>
            <span 
              className="text-[#0067ff] text-sm uppercase tracking-widest font-medium mb-4 block"
              style={{
                opacity: isInView ? 1 : 0,
                transform: isInView ? 'translateX(0)' : 'translateX(-120px)',
                transition: 'all 1.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
              }}
            >
              {t.about.label}
            </span>
            <h2 
              className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-6"
              style={{
                opacity: isInView ? 1 : 0,
                transform: isInView ? 'perspective(400px) rotateX(0deg)' : 'perspective(400px) rotateX(-90deg) translateY(-50px)',
                transition: 'all 1.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.3s'
              }}
            >
              {t.about.title}
            </h2>
            <div 
              className="h-1 bg-[#0067ff]"
              style={{
                width: isInView ? '5rem' : '0',
                opacity: isInView ? 1 : 0,
                transition: 'all 1.2s ease-out 0.6s'
              }}
            />
            
            {/* Decorative Image */}
            <div className="mt-12 relative">
              <div 
                className="aspect-[4/3] bg-gray-300 rounded-lg overflow-hidden relative group"
                style={{
                  opacity: isInView ? 1 : 0,
                  transform: isInView ? 'translateY(0) scale(1)' : 'translateY(80px) scale(0.85)',
                  transition: 'all 1.4s ease-out 0.8s'
                }}
              >
                <img
                  src="https://customer-assets.emergentagent.com/job_studio149-barber/artifacts/11jihk69_crnac.jpg"
                  alt="Studio 149 Barbershop Zemun - Enterijer salona"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute bottom-0 right-0 w-20 h-20 border-r-4 border-b-4 border-[#0067ff] transition-all duration-500 group-hover:w-28 group-hover:h-28" />
              </div>
            </div>
          </div>

          {/* Right Column - Text */}
          <div>
            <div className="prose prose-lg max-w-none">
              <h3 
                className="text-xl font-serif font-semibold text-white mb-4"
                style={{
                  opacity: isInView ? 1 : 0,
                  transform: isInView ? 'translateX(0)' : 'translateX(80px)',
                  transition: 'all 1.2s ease-out 0.4s'
                }}
                dangerouslySetInnerHTML={{
                  __html: t.about.subtitle.replace(/21/g, '<span style="font-size: 1.5em; font-weight: bold;">21</span>')
                }}
              />
              
              <p 
                className="text-gray-200 leading-relaxed mb-6 text-base"
                style={{
                  opacity: isInView ? 1 : 0,
                  transform: isInView ? 'translateX(0)' : 'translateX(80px)',
                  transition: 'all 1.2s ease-out 0.5s'
                }}
              >
                {t.about.p1}
              </p>
              
              <p 
                className="text-gray-200 leading-relaxed mb-6 text-base"
                style={{
                  opacity: isInView ? 1 : 0,
                  transform: isInView ? 'translateX(0)' : 'translateX(80px)',
                  transition: 'all 1.2s ease-out 0.75s'
                }}
              >
                {t.about.p2}
              </p>
              
              <p 
                className="text-gray-200 leading-relaxed mb-6 text-base"
                style={{
                  opacity: isInView ? 1 : 0,
                  transform: isInView ? 'translateX(0)' : 'translateX(80px)',
                  transition: 'all 1.2s ease-out 1s'
                }}
              >
                {t.about.p3}
              </p>
              
              <p 
                className="text-gray-200 leading-relaxed mb-6 text-base"
                style={{
                  opacity: isInView ? 1 : 0,
                  transform: isInView ? 'translateX(0)' : 'translateX(80px)',
                  transition: 'all 1.2s ease-out 1.25s'
                }}
              >
                {t.about.p4}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
